module.exports = __webpack_public_path__ + "media/images/file-icons/512/008-archive-0161d8bad49b250ab65a89b809ffaef7.png";